export const removeLeadingSlash = (text: string) =>
  text.charAt(0) === '/' ? text.substr(1) : text
